import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const DesktopProduct = () => {
  // const linkClass =
  //   "flex justify-between px-4 items-center  py-2 rounded font-medium text-gray-800 no-underline  hover:text-main transition-colors duration-300";
  const linkClass = `
  flex justify-between items-center px-3 py-2  font-medium
  text-gray-800 no-underline transition-colors duration-300
  hover:bg-main hover:text-white
`;
  const Services = [
    {
      name: "Interactive Voice Response",
      path: "/interactive-voice-response",
    },
    {
      name: "Missed Call Alert Services",
      path: "/missed-call-alert-services",
    },

    {
      name: "Leads Management System",
      path: "/Leads-management-system",
    },
    { name: "Bulk SMS", path: "/bulk-sms" },
    {
      name: "Virtual Phone Number",
      path: "/virtual-phone-number",
    },
    {
      name: "Customer relationship management",
      path: "/customer-relationship",
    },
    {
      name: "Employee Tracking System",
      path: "/employee-tracking-system",
    },
  ];

  return (
    <div className="w-[300px] bg-white rounded shadow-2xl  text-sm text-gray-800">
      <ul className=" pl-0 text-[15px] mt-1 ">
        {Services.map((item) => (
          <li key={item.path}>
            <Link to={item.path} className={linkClass}>
              <span>{item.name}</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DesktopProduct;
